import { z } from "zod";

export const sampleEnquirySchema = z.object({
  website: z.string().trim().min(1, "Please enter your website domain").max(500, "Website is too long"),
  email: z.string().trim().email("Please enter a valid email address").max(255, "Email is too long"),
  company: z.string().max(0, "Unable to submit this enquiry. Please try again."),
});